const sizes = {
  heroesPaddingTop: '10rem',
  heroesMobilePaddingTop: '12rem',
  heroesTitleMobileMarginTop: '4rem',
}

export default sizes
